module.exports = __webpack_public_path__ + "img/kehu_gaonenghuanjing.a549b869.png";